'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sectionProduct = require('./directives/sectionProduct.js');

var _sectionProduct2 = _interopRequireDefault(_sectionProduct);

var _productRelatedProducts = require('./directives/productRelatedProducts.js');

var _productRelatedProducts2 = _interopRequireDefault(_productRelatedProducts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appName = 'module.sections.product';

var _module = angular.module(appName, ['ngResource', 'ui.bootstrap-slider', 'infinite-scroll', 'ap.fotorama', 'rzModule']);

// directives


_module.directive('sectionProduct', _sectionProduct2.default).directive('productRelatedProducts', _productRelatedProducts2.default);

exports.default = appName;


//////////////////
// WEBPACK FOOTER
// ./app/modules/sections/product/product.js
// module id = 19
// module chunks = 0